import { NgModule } from '@angular/core';
import { FormsModule , ReactiveFormsModule} from '@angular/forms';
import { CommonModule} from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslatePipeModule } from '../../translate/translate.pipe.module';

import { SearchFilterComponent } from './search-filter.component';
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TranslatePipeModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [SearchFilterComponent],
  providers: [],
  exports: [SearchFilterComponent]
})

export class SearchFilterModule {

}
